import { CompactContentCardConfig } from "@ui/context/component-config-context";
import { RecursivePartial } from "@voxmedia/duet-utils/typescript";

const compactContentCardConfig: RecursivePartial<CompactContentCardConfig> = {
  imagePosition: "right",
  lowerMetaSecondComponent: "Timestamp",
  lowerMetaThirdComponent: "CommentCount",
  upperMetaFirstComponent: "LiveBadge",
  upperMetaSecondComponent: null,
  showDek: false,
  componentContext: {
    articleParentRecircStream: {
      imagePosition: "hideImage",
      showDek: false,
      upperMetaFirstComponent: null,
      upperMetaSecondComponent: null,
      contentBlockSize: "small",
    },
    articleParentRecircPackage: {
      imagePosition: "left",
      showDek: false,
      upperMetaFirstComponent: null,
      upperMetaSecondComponent: null,
      contentBlockSize: "small",
    },
    fiveGridPackagePattern: {
      contentBlockSize: "small",
      contentBlockVariation: "standard",
      imagePosition: "right",
      lowerMetaSecondComponent: null,
      showDek: false,
      upperMetaFirstComponent: null,
      upperMetaSecondComponent: null,
    },
    latestRecirc: {
      latestRecircPadding: true,
      lowerMetaFirstComponent: null,
      lowerMetaSecondComponent: null,
      lowerMetaThirdComponent: null,
    },
    riverLinkPost: {
      upperMetaFirstComponent: "ContentBlockCrossPost",
      lowerMetaFirstComponent: null,
      lowerMetaSecondComponent: null,
      showDek: true,
    },
    /** Following feed: Live first when live, category second (posts use riverFollow; link posts use riverFollowLinkPost). */
    riverFollow: {
      upperMetaFirstComponent: "LiveBadge",
      upperMetaSecondComponent: "Category",
      lowerMetaFirstComponent: null,
      lowerMetaSecondComponent: null,
      showDek: true,
    },
    riverFollowLinkPost: {
      upperMetaFirstComponent: "LiveBadge",
      upperMetaSecondComponent: "Category",
      lowerMetaFirstComponent: null,
      lowerMetaSecondComponent: null,
      showDek: true,
    },
    threeGridArticleCategoryRecirc: {
      latestRecircPadding: true,
      upperMetaFirstComponent: null,
      upperMetaSecondComponent: null,
      showDek: false,
    },
    sixUpPatternTop: {
      upperMetaFirstComponent: "LiveBadge",
      lowerMetaFirstComponent: "ContentBlockByline",
      lowerMetaSecondComponent: "Timestamp",
      lowerMetaThirdComponent: "CommentCount",
      imageAspectRatio: "square",
      contentBlockSize: "small",
      alignTop: true,
    },
    sixUpPatternBottom: {
      contentBlockVariation: "standard",
      upperMetaFirstComponent: "LiveBadge",
      lowerMetaFirstComponent: "ContentBlockByline",
      lowerMetaSecondComponent: "Timestamp",
      lowerMetaThirdComponent: "CommentCount",
      imageAspectRatio: "square",
      imagePosition: "right",
      contentBlockSize: "small",
      mediaVariationIconPlacement: "thumbnail",
      alignTop: true,
    },
    sixUpPatternMobile: {
      upperMetaFirstComponent: null,
      upperMetaSecondComponent: null,
      upperMetaThirdComponent: null,
      lowerMetaFirstComponent: "ContentBlockByline",
      lowerMetaSecondComponent: "Timestamp",
      lowerMetaThirdComponent: "CommentCount",
      imageAspectRatio: "square",
      imagePosition: "left",
      contentBlockSize: "small",
      showDek: false,
    },
    listBreaker: {
      upperMetaFirstComponent: null,
      lowerMetaFirstComponent: "ContentBlockByline",
      lowerMetaSecondComponent: "Timestamp",
      lowerMetaThirdComponent: "CommentCount",
      imagePosition: "hideImage",
      contentBlockSize: "small",
    },
    categoryBreaker: {
      upperMetaFirstComponent: null,
      lowerMetaFirstComponent: "ContentBlockByline",
      lowerMetaSecondComponent: "Timestamp",
      lowerMetaThirdComponent: "CommentCount",
      imagePosition: "hideImage",
      contentBlockSize: "micro",
    },
    fourUpPattern: {
      upperMetaSecondComponent: null,
      imageAspectRatio: "square",
      contentBlockSize: "small",
      imagePosition: "right",
      lowerMetaFirstComponent: "ContentBlockByline",
      lowerMetaSecondComponent: "Timestamp",
      lowerMetaThirdComponent: "CommentCount",
      metaVariation: "box",
    },
    searchPage: {
      showDek: true,
      upperMetaFirstComponent: null,
      alignTop: true,
    },
    searchPageWithoutCategory: {
      showDek: true,
      upperMetaFirstComponent: null,
      alignTop: true,
    },
    packageLayoutPosts: {
      upperMetaFirstComponent: "LiveBadge",
    },
    threeDailyReadPattern: {
      upperMetaFirstComponent: null,
      imagePosition: "left",
      imageAspectRatio: "square",
      contentBlockSize: "micro",
      alignTop: true,
      showDek: true,
      lowerMetaSecondComponent: "CommentCount",
      lowerMetaThirdComponent: null,
    },
    threeDailyReadPatternMobile: {
      upperMetaFirstComponent: null,
      imageAspectRatio: "square",
      contentBlockSize: "micro",
      showDek: true,
      lowerMetaSecondComponent: "CommentCount",
      lowerMetaThirdComponent: null,
    },
    twoGridAltPatternHero: {
      imagePosition: "left",
      contentBlockSize: "small",
      lowerMetaSecondComponent: "CommentCount",
      lowerMetaThirdComponent: null,
    },
    homepageFeed: {
      upperMetaFirstComponent: "LiveBadge",
      lowerMetaFirstComponent: "ContentBlockByline",
      lowerMetaSecondComponent: "Timestamp",
      lowerMetaThirdComponent: "CommentCount",
      showDek: true,
      alignTop: true,
      contentBlockSize: "small",
    },
    homepageFeedLinkPost: {
      upperMetaFirstComponent: "ContentBlockCrossPost",
      lowerMetaFirstComponent: null,
      lowerMetaSecondComponent: null,
      showDek: true,
      alignTop: true,
      contentBlockSize: "small",
    },
    /** Homepage Following feed matches Latest card chrome; keep live badge but omit category eyebrows. */
    homepageFeedFollow: {
      upperMetaFirstComponent: "LiveBadge",
      upperMetaSecondComponent: null,
      lowerMetaFirstComponent: "ContentBlockByline",
      lowerMetaSecondComponent: "Timestamp",
      lowerMetaThirdComponent: "CommentCount",
      showDek: true,
      alignTop: true,
      contentBlockSize: "small",
    },
    homepageFeedFollowLinkPost: {
      upperMetaFirstComponent: "LiveBadge",
      upperMetaSecondComponent: null,
      lowerMetaFirstComponent: null,
      lowerMetaSecondComponent: null,
      showDek: true,
      alignTop: true,
      contentBlockSize: "small",
    },
  },
};

export default compactContentCardConfig;
